<template>
    <div class="single">
        <div class="meeting-overview-data">
            <div class="main-data mt-0">
                <div class="main-data-left">
                    <div class="ioc"><img src="@/assets/images/main-data-ioc01.png"></div>
                    <div class="size">
                        <div>报名人数</div>
                        <div class="data"><span>{{statistics.total}}</span><div>(人)</div></div>
                    </div>
                </div>
                <div class="main-data-left two">
                    <div class="ioc"><img src="@/assets/images/main-data-ioc02.png"></div>
                    <div class="size">
                        <div>参会人数</div>
                        <div class="data"><span>{{statistics.attend}}</span><div>(人)</div></div>
                    </div>
                </div>
                <div class="main-data-left three">
                    <div class="ioc"><img src="@/assets/images/main-data-ioc03.png"></div>
                    <div class="size">
                        <div>签到人数</div>
                        <div class="data"><span>{{statistics.sign}}</span><div>(人)</div></div>
                    </div>
                </div>
            </div>

            <div class="overview-data">
                <IEcharts :option="attend"/>
            </div>

            <div class="overview-data">
                <IEcharts :option="sms"/>
            </div>
        </div>
    </div>
</template>

<script>
    import IEcharts from 'vue-echarts-v3/src/full.js';
    let that
    export default {
        name: "meetingManagerStatisticsData",
        props: ['id'],
        components: {
            IEcharts
        },
        data () {
            return {
                statistics: {},
                attend: {
                    title: {
                        textStyle: {
                            fontWeight: 'normal',
                            color: '#a8a8a8'
                        },
                        text:'参会人员',
                        padding: 25
                    },
                    grid: {
                        top: '26%',
                        left: '5%',
                        right: '3%',
                        bottom: '13%'
                    },
                    xAxis: {
                        type: 'category',
                        data: [],
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: false
                        }
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                },
                sms: {
                    title: {
                        textStyle: {
                            fontWeight: 'normal',
                            color: '#a8a8a8'
                        },
                        text:'短信发送',
                        padding: 25
                    },
                    grid: {
                        top: '26%',
                        left: '5%',
                        right: '3%',
                        bottom: '13%'
                    },
                    xAxis: {
                        type: 'category',
                        data: ['04-01', '04-02', '04-05', '04-08', '04-11', '04-15', '04-18'],
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: false
                        }
                    },
                    series: [{
                        data: [11, 50, 30, 40, 60, 20, 10],
                        type: 'line'
                    }]
                }
            }
        },
        mounted () {
            that = this
            that.$api.statistics.sign(that.id).then(function(res){
                that.statistics = res.data;
            })
            that.$api.statistics.attendTrend(that.id).then(function(res){
                that.attend.xAxis.data = res.data.x;
                that.attend.series[0].data = res.data.y;
            })
            that.$api.statistics.smsTrend(that.id).then(function(res){
                that.sms.xAxis.data = res.data.x;
                that.sms.series[0].data = res.data.y;
            })
        }
    }
</script>

<style scoped>

</style>